import * as React from "react"

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
const ContactUsIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    {...props}
  >
    <path
      d="M2 3.33325H14V11.3333C14 12.0696 13.403 12.6666 12.6667 12.6666H3.33333C2.59695 12.6666 2 12.0696 2 11.3333V3.33325Z"
      stroke="#292929"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 3.33325L8 9.33325L14 3.33325"
      stroke="#292929"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export {ContactUsIcon}
